<span class="description">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.RETAIL_PAYMENT.DESCRIPTION' | translate }}
</span>
<div class="padding">
  <glxy-form-field [required]="true">
    <mat-select [formControl]="statusControl">
      <mat-option *ngFor="let option of options" [value]="option.value">
        {{ option.label | translate }}
      </mat-option>
    </mat-select>
  </glxy-form-field>
</div>

<glxy-alert type="tip">
  <div [innerHtml]="'AUTOMATIONS.EDITOR.TRIGGERS.RETAIL_PAYMENT.DISCLAIMER' | translate"></div>
</glxy-alert>
